import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Clock = createSvgIcon(
  () => (
    <path d="M24.2188 0C10.8398 0 0 10.8398 0 24.2188C0 37.5977 10.8398 48.4375 24.2188 48.4375C37.5977 48.4375 48.4375 37.5977 48.4375 24.2188C48.4375 10.8398 37.5977 0 24.2188 0ZM29.7852 34.2773L21.0938 27.9297C20.8008 27.7344 20.7031 27.4414 20.7031 27.0508V10.5469C20.7031 9.96094 21.1914 9.375 21.875 9.375H26.5625C27.1484 9.375 27.7344 9.96094 27.7344 10.5469V24.0234L33.8867 28.5156C34.375 28.9062 34.5703 29.6875 34.1797 30.1758L31.3477 33.9844C31.0547 34.4727 30.2734 34.5703 29.7852 34.2773Z" />
  ),
  '0 0 49 49'
);
